import Vue from 'vue';
import routerPageHook from '@assets/js/routerPageHook.js';
import BannerBtn from '@components/ui-components/banner-btn/component.js';
import formVacancies from '@components/base/forms/form-vacancies.vue';

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',

        }
    },
    components: {
        'banner-btn-cmp': BannerBtn,
        'cmp-form-vacancies': formVacancies
    },
    methods: {

    },
    ...routerPageHook,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};



// WEBPACK FOOTER //
// ./src/templates/pages/career/view/index.js